import { copies, deliveryMethodNames } from '@reveni-io/reveni-ui'

const DELIVERY_METHOD_PREFIX = 'delivery_method.'

const toShortKey = fullKey => fullKey?.replace(DELIVERY_METHOD_PREFIX, '') || ''

export const getReturnMethodType = fullKey => toShortKey(fullKey)

export const getReturnMethodTitle = fullKey => deliveryMethodNames[toShortKey(fullKey)] || ''

export const getReturnMethodMessage = (fullKey, customCopies, lang) => {
  const customMessage = customCopies?.[lang]?.[fullKey]?.message

  if (customMessage) return customMessage

  return copies[lang]?.returnMethods?.[toShortKey(fullKey)] || ''
}
